import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { media } from '../../../styles/newTheme/theme'

const sidebarBgLight = 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)'
const sidebarBgDark = 'linear-gradient(180deg, #0a0f1a 0%, #111827 100%)'

export const SidebarContainer = styled.aside<{ $isCollapsed: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${({ $isCollapsed }) => ($isCollapsed ? '72px' : '240px')};
  min-height: 100vh;
  background: ${({ theme }) => (theme.palette.mode === 'dark' ? sidebarBgDark : sidebarBgLight)};
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border-right: 1px solid
    ${({ theme }) => (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.06)')};

  ${media.down('l')} {
    display: none;
  }
`

export const MobileSidebarContainer = styled.aside`
  display: none;
  flex-direction: column;
  width: min(240px, 80vw);
  min-height: 100vh;
  background: ${({ theme }) => (theme.palette.mode === 'dark' ? sidebarBgDark : sidebarBgLight)};
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;

  ${media.down('l')} {
    display: flex;
  }
`

export const SidebarOverlay = styled.div`
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  z-index: 25;

  ${media.down('l')} {
    display: block;
  }
`

export const LogoArea = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  min-height: 72px;

  img {
    max-height: 36px;
    width: auto;
  }

  img.collapsed-logo {
    max-height: 32px;
    width: 32px;
    object-fit: contain;
  }
`

export const SidebarDivider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 0 20px;
`

export const NavGroup = styled.nav`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 10px;
`

export const NavItemLink = styled(NavLink)<{ $isCollapsed: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: ${({ $isCollapsed }) => ($isCollapsed ? '10px' : '10px 16px')};
  justify-content: ${({ $isCollapsed }) => ($isCollapsed ? 'center' : 'flex-start')};
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.9);
  }

  &.active {
    background: rgba(37, 99, 235, 0.15);
    color: #60a5fa;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 24px;
      background: #2563eb;
      border-radius: 0 3px 3px 0;
    }
  }
`

export const NavItemIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const NavItemText = styled.span<{ $isCollapsed: boolean }>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'inline')};
  white-space: nowrap;
`
